import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m16.56 5.56 4.026 4.026a2 2 0 0 1 0 2.828L16.56 16.44c-.945.945-2.561.276-2.561-1.06V14c-1.866 0-5.908 0-10.096 4.06-.329.32-.887.09-.845-.365C3.792 9.804 11.15 8 13.999 8V6.621c0-1.336 1.617-2.005 2.562-1.06"
    }
  )
);
var SvgForwardFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ForwardFilled_default = SvgForwardFilled;

export { ForwardFilled_default as default };
